import styled from 'styled-components'

export const MaterialLoading = styled.div`
width: 100%;
height: 100%;
background: #222;
opacity: 0.7;
position: absolute;
z-index: 2;
`

export const Container = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  div#SimulatorTopBar {
      display: flex;
      flex: 1;
    }

  iframe {
    background-color: ${props => props.backgroundColor};
    height: 100vh;
    position: relative;
    width: 100%;
    z-index: 1;
    border: 0;
  }

  @media only screen and (min-width: 1024px) {
    i.fa-compress {
    display: none !important;
    }
  }

  i.fa-compress {
    display: ${props => props.displayCompressIcon ? 'block' : 'none'};
    color: ${props => props.backgroundColor};
    font-size: 22px;
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 2;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }

  div.offline {
    display: flex;
    align-items: center;
    height: 20px;
    width: fit-content;
    left: 0; 
    right: 0; 
    margin-left: auto; 
    margin-right: auto; 
    background-color: ${props => props.backgroundColor};
    position: absolute;
    top: 50px;
    align-self: center;
    z-index: 8;
    font-size: 11px;
    font-weight: 500;
    padding-left: 16px;
    border-radius: 10px;
    opacity: .8;
    box-shadow: 0 0.2px 4px rgba(0, 0, 0, 0.10);
  }

  i.fa-wifi {
    position: relative;
    margin-left: 12px;
    font-size: 12px;
  }

  i.fa-slash {
    position: relative;
    right: 15px;
    z-index: 9;
    font-size: 12px;
  }

  div#expand-button2{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 35px;
    border-radius: 18px;
    position: absolute;
    z-index: 2;
    right: 8px;
    bottom: 108px;
    background-color: #fff;
    padding: 6px;
    cursor: pointer;
    animation-name: example5;
    animation-duration: 2s;  
    animation-fill-mode: forwards;
    :hover {
      opacity: .7;
      box-shadow: 3px 3px 3px 0px #666;
    }
    transition: 0.3s;
  }

  @keyframes example5 {
    from {right: -100%;}
    to {right: 16px;}
  }

  div#expand-button2 i{
  font-size: 20px;
  font-weight: bold;
  }

  @media only screen and (max-width: 1024px) {
    div#expand-button2{
      display: none;
    }
  }

  div#expand-button2.active{
    background-color: #222;
  }

  div#expand-button2.active i{
    color: #fff;
  }
`

export const MoodboardCard = styled.div`
  width: 96vw;
  height: auto;
  position: fixed;
  z-index: 20;
  top: 20vh;
  background-color: ${props => props.backgroundColor};
  border-radius: 16px;
  margin: auto 2vw;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);

  @media only screen and (min-width: 1024px) {
    width: 36vw;
    left: 50%;
    margin-left: -18vw;
    z-index: 5;
    top: 12vh;

    img {
      width: 36vw !important;
      height: 27vw !important;
    }

    i.fa-times {
      top: 16px !important;
      right: 20px !important;
    }

    input {
      width: 30vw !important;
      margin: 0px 3vw 16px 3vw !important;
    }

    div button {
      width: 118px !important;
    }
  }

  input {
    position: relative;
    border-radius: 16px;
    height: 28px;
    margin: 0px 4vw 16px 4vw;
    width: 88vw;
    background: ${props => props.backgroundColor};
    color: rgba(20, 20, 20, 0.6);
    font-size: 12px;
    border: 1px solid rgba(20, 20, 20, 0.2);
    padding: 0 16px 0 16px;
  }

  input:focus-within,
  input:hover {
    border: 1px solid ${props => props.brandColor};
  }

  i.fa-times {
    font-size: 20px;
    margin: 0 0 1.2rem 0.5rem;
    position: absolute;
    top: 3vw;
    right: 4vw;
    z-index: 11;
    color: ${props => props.backgroundColor};
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  i.fa-times:hover {
    opacity: .8;
    box-shadow: 3px 3px 3px 0px #666;
  }

  .img-gradient {
    position: absolute;
    width: 100%;
    bottom: 0;
    margin-bottom: 0;
    height: 30%;
    background: linear-gradient(rgba(245,245,245,0),rgba(245,245,245,1));
  }

  h1 {
    color: ${props => props.fontColor};
    font-size: 14px;
    margin: 0 0 0.4rem .8rem;
    font-weight: 500;
    text-align: center;
  }

  img {
    position: relative;
    border-radius: 16px 16px 0 0;
    width: 96vw;
    height: 72vw;
  }

  h2 {
    font-size: 11px;
    color: ${props => props.fontColor};
    font-weight: 500;
    text-align: center;
    margin: 24px 4vw 16px 4vw;
  }

  div {
    position: relative;
    display: flex;
    flex-wrap: no-wrap;
    justify-content: center;
    margin-bottom: 16px;
  }

  div button {
    display: flex;
    position: relative;
    width: 138px;
    height: 32px;
    border-radius: 16px;
    border: none;
    font-size: 12px;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    justify-content: center;
    align-items: center;
    margin: auto 4px auto 4px;
    font-family: 'Montserrat',sans-serif;
    font-weight: 500;
    color: ${props => props.brandContrastColor};
    background-color: ${props => props.brandColor};
  }

  div button.replace-button {
    color: ${props => props.fontColor};
    background-color: ${props => props.backgroundColor};
  }

  div button.new-environment-button {
    color: ${props => props.backgroundColor};
    background-color: ${props => props.brandColor};
  }

  div button.new-environment-button img {
    width: 16px;
  }

  button:hover {
    opacity: .8;
    cursor: pointer;
    box-shadow: 3px 3px 3px 0px #666;
  }
`

export const DesktopInpirationModal = styled.div`
  display: none;
  width: 80vw;
  height: auto;
  position: fixed;
  z-index: 20;
  top: 6vh;
  left: 10vw;
  padding: 2vh 2vw 2vh 2vw;
  background-color: ${props => props.backgroundColor};
  border-radius: 16px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);

  i.fa-times {
    font-size: 20px;
    margin: 0 0 1.2rem 0.5rem;
    position: absolute;
    top: 28px;
    right: 32px;
    z-index: 11;
    color: ${props => props.fontColor};
    opacity: .8;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  i.fa-times:hover {
    opacity: .7;
    box-shadow: 3px 3px 3px 0px #666;
  }

  h1.modal-title {
    color: ${props => props.brandColor};
    font-size: 28px;
    margin: 24px 0 0.4rem 0;
    font-weight: 700;
    text-align: center;
    width: 100%;
  }

  h2.modal-subtitle {
    color: ${props => props.fontColor};
    font-size: 14px;
    margin: 0 0 24px 0;
    font-weight: 500;
    text-align: center;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 24px;
  }

  button {
    display: flex;
    position: relative;
    float: right;
    width: auto;
    height: 32px;
    padding-right: 16px;
    padding-left: 16px;
    border-radius: 16px;
    border: none;
    font-size: 12px;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    justify-content: center;
    align-items: center;
    margin: 8px 4px 8px 4px;
    font-family: 'Montserrat',sans-serif;
    font-weight: 500;
    color: ${props => props.brandColor};
    background-color: ${props => props.backgroundColor};
  }

  button:hover {
    opacity: .7;
    cursor: pointer;
  }

  button.button-back:disabled, 
  button.button-next:disabled {
    display: none;
  }
`
/*
export const OpenModal = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 18px;
    position: absolute;   
    z-index: 2;
    right: 8px;
    bottom: 94.5px;
    padding: 6px;
    cursor: pointer;
    background-color: #fff;
    :hover {
      box-shadow: 3px 3px 3px 0px #666;
      opacity: .7;
    }

    i{
      font-size: 25px;
      color: #000;
    }

  @media only screen and (min-width: 1024px) {
    display: none !important;
  }

  @media only screen and (min-height: 1750px) and (max-width: 1080px) {
    bottom: 16px;
    width: 72px;
    height: auto;
    display: flex !important;
    transform: translateX(-50%);
    left: 50%;
    right: auto;
  }



`*/

export const OpenModal = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 18px;
    position: absolute;   
    z-index: 2;
    padding: 6px;
    cursor: pointer;
    background-color: #fff;

    bottom: 16px;
    width: 72px;
    height: auto;    
    transform: translateX(-50%);
    left: 50%;

    :hover {
      box-shadow: 3px 3px 3px 0px #666;
      opacity: .7;
    }

    i{
      font-size: 25px;
      color: #000;
    }

  @media only screen and (orientation: landscape) {
    display: none !important;
  }


`

export const ChangeCamera = styled.img`
  width: 30px;
  border-radius: 15px;
  position: absolute;
  z-index: 2;
  right: 8px;
  bottom: 18px;
  background-color: #fff;
  padding: 4px;
  cursor: pointer;
  :hover {
    opacity: .7;
    box-shadow: 3px 3px 3px 0px #666;
  }

  @media only screen and (min-width: 1024px) {
    bottom: 16px;
    width: 36px;
    border-radius: 18px;
    padding: 6px;
    animation-name: example3;
    animation-duration: 2s;  
    animation-fill-mode: forwards;

      @keyframes example3 {
        from {right: -100%;}
        to {right: 16px;}
      }
  }
`
export const CameraForward = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  position: absolute;
  z-index: 2;
  right: 8px;
  bottom: 56px; 
  background-color: ${props => props.backgroundColor};
  padding: 4px;
  cursor: pointer;
  background-image: url("data:image/svg+xml;base64,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");
  background-size: 20px;    
  background-repeat: no-repeat;
  background-position: center;
  :hover {
    opacity: .7;
    box-shadow: 3px 3px 3px 0px #666;
  }

  @media only screen and (min-width: 1024px) {
    right: 16px;
    /* bottom: 16px; */
    bottom: auto;
    width: 60px;
    height: 60px;
    border-radius: 50px;
    padding: 6px;
    

    background-image: url("data:image/svg+xml;base64,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");
    background-size: 45px;    
    background-repeat: no-repeat;
    background-position: center;    
  }
`

export const CameraBackward = styled.img`
  width: 30px;
  height: 30px;  
  border-radius: 15px;
  position: absolute;
  z-index: 2;
  left: 316px;
  right: 8px;
  display: none;
  background-color: ${props => props.backgroundColor};
  padding: 4px;
  cursor: pointer;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8Zz4NCgkJCTxwYXRoIGQ9Ik00NDgsMjgzLjkxM1YxMDYuNjY3QzQ0OCw4My4xMzYsNDI4Ljg2NSw2NCw0MDUuMzMzLDY0aC00NC41Yy0yLjgwMiwwLTUuNTUyLTEuMTM1LTcuNTQyLTMuMTI1bC0zMC4xNjctMzAuMTY3DQoJCQkJYy02LjA0Mi02LjA0Mi0xNC4wODMtOS4zNzUtMjIuNjI1LTkuMzc1aC04OWMtOC41NDIsMC0xNi41ODMsMy4zMzMtMjIuNjI1LDkuMzc1bC0zMC4xNjcsMzAuMTY3DQoJCQkJYy0xLjk5LDEuOTktNC43NCwzLjEyNS03LjU0MiwzLjEyNWgtNDQuNUM4My4xMzUsNjQsNjQsODMuMTM2LDY0LDEwNi42Njd2MTc3LjI3MWMtNTIuMjY4LDIxLjk5MS02NCw0Ny41MTYtNjQsNjUuNDQ4DQoJCQkJYzAsNDkuNDU2LDg2LjE3Myw4Ny44MTksMjA1LjkyMiw5NC44MjRsLTEzLjEzOCwxMy4xMzljLTQuMTcxLDQuMTY4LTQuMTcxLDEwLjkyOCwwLDE1LjA5NmwxNS4wOTIsMTUuMDk1DQoJCQkJYzQuMTcxLDQuMTY4LDEwLjkyOCw0LjE2OCwxNS4wOTksMGw0OC4zMjktNDguMzMxYzguMzM3LTguMzM5LDguMzM3LTIxLjg1NCwwLTMwLjE5MWwtNDMuNTk4LTQzLjU5OA0KCQkJCWMtNC4xNzEtNC4xNjktMTAuOTI4LTQuMTY5LTE1LjA5OCwwbC0xNS4wOTQsMTUuMDk0Yy00LjE3MSw0LjE2OS00LjE3MSwxMC45MjgsMCwxNS4wOThsNS42Niw1LjY2DQoJCQkJYy0xMDYuNTk0LTcuMzMzLTE1OS4xNDgtNDAuODc4LTE2MC40NzQtNTEuODE0YzAuMjgxLTIuMjk3LDYuNzAyLTEyLjE1MSwzMS4zOTUtMjMuNTU3YzcuODMyLDkuMzUsMTkuNDQ0LDE1LjQzMiwzMi41NywxNS40MzINCgkJCQloMjk4LjY2N2MxMy4xMywwLDI0Ljc0NS02LjA4NSwzMi41NzctMTUuNDRjMjQuNTczLDExLjMzNywzMS4xNDUsMjEuMzYzLDMxLjQwOSwyMy4yMjENCgkJCQljLTEuNTIyLDguMDY5LTM5LjE2NywzOS45MzktMTQxLjY3Nyw1MC41NTJsLTEwLjYxOCwxLjFjLTUuODY1LDAuNjA3LTEwLjEyNSw1Ljg1My05LjUxOCwxMS43MTlsMi4yMDEsMjEuMjM0DQoJCQkJYzAuNjA3LDUuODY1LDUuODUzLDEwLjEyNSwxMS43MTcsOS41MThsMTAuNjE5LTEuMUM0MzkuNjgxLDQzMC45OTQsNTEyLDM5My43MjQsNTEyLDM0OS4zODYNCgkJCQlDNTEyLDMzMS40MDksNTAwLjI5NiwzMDUuODE4LDQ0OCwyODMuOTEzeiBNMjU2LDI3Ny4zMzNjLTQ3LjA1MiwwLTg1LjMzMy0zOC4yODEtODUuMzMzLTg1LjMzMw0KCQkJCWMwLTQ3LjA1MiwzOC4yODEtODUuMzMzLDg1LjMzMy04NS4zMzNzODUuMzMzLDM4LjI4MSw4NS4zMzMsODUuMzMzQzM0MS4zMzMsMjM5LjA1MiwzMDMuMDUyLDI3Ny4zMzMsMjU2LDI3Ny4zMzN6IE0zODQsMTQ5LjMzMw0KCQkJCWMtMTEuNzYsMC0yMS4zMzMtOS41NzMtMjEuMzMzLTIxLjMzM2MwLTExLjc2LDkuNTczLTIxLjMzMywyMS4zMzMtMjEuMzMzYzExLjc2LDAsMjEuMzMzLDkuNTczLDIxLjMzMywyMS4zMzMNCgkJCQlDNDA1LjMzMywxMzkuNzYxLDM5NS43NiwxNDkuMzMzLDM4NCwxNDkuMzMzeiIvPg0KCQkJPGNpcmNsZSBjeD0iMjU2IiBjeT0iMTkyIiByPSI2NCIvPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo=");
  background-size: 20px;    
  background-repeat: no-repeat;
  background-position: center;  
  :hover {
    opacity: .7;
    box-shadow: 3px 3px 3px 0px #666;
  }

  @media only screen and (min-width: 1024px) {
    /*right: 16px;*/
    /* bottom: 16px; */
    display: block;
    width: 60px;
    height: 60px;    
    border-radius: 50px;
    padding: 6px;

    background-image: url("data:image/svg+xml;base64,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");
    background-size: 45px;    
    background-repeat: no-repeat;
    background-position: center;       
  }
`

export const EraseMaterial = styled.img`
  width: 30px;
  border-radius: 15px;
  position: absolute;
  z-index: 2;
  right: 8px;
  bottom: 102px;
  background-color: ${props => props.backgroundColor};
  padding: 6px;
  cursor: pointer;
  :hover {
    opacity: .7;
    box-shadow: 3px 3px 3px 0px #666;
  }

  @media only screen and (min-width: 1024px) {
    right: 16px;
    bottom: 64px;
    width: 36px;
    border-radius: 18px;
    padding: 8px;
  }
`

export const ScreenshotBtn = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 18px;
    position: absolute;   
    z-index: 2;
    right: 8px;
    bottom: 56px;
    background-color: #fff;
    padding: 6px;
    cursor: pointer;
    :hover {
      opacity: .7;
      box-shadow: 3px 3px 3px 0px #666;
    }

    i{
      font-size: 20px;
      color: #000;
    }

  @media only screen and (min-width: 1024px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 18px;
    position: absolute;   
    z-index: 2;
    right: 8px;
    bottom: 62px;
    background-color: #fff;
    padding: 6px;
    cursor: pointer;
    animation-name: example4;
    animation-duration: 2s;  
    animation-fill-mode: forwards;

      @keyframes example4 {
        from {right: -100%;}
        to {right: 16px;}
      }

      i{
      font-size: 22px;
      color: #000;
    }
  }
`